import React, {useState, useEffect} from "react";
import {Helmet} from "react-helmet";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import validator from "validator";
import Alert from '../partials/Alert';
import configVars from "../config";

const ContactUs = () => {

    const [translation] = useTranslation("translations");
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const userData = useSelector((state) => state.userdata?.allUserData);
    const [displayAlert, setDisplayAlert] = useState( { type: '', msg: '' } );
    const [sending, setSending] = useState(false);

    useEffect(() => {
        
        if ( ! userData ) return;

        if ( userData.first_name ) {
            setFirstName( userData.first_name );
        }

        if ( userData.last_name ) {
            setLastName( userData.last_name );
        }

        if ( userData.email ) {
            setEmail( userData.email );
        }

    }, [userData]);

    const handleSend = async () => {

        const validation = handleValidation( firstName, lastName, email, message );

        if ( ! validation.isValidated ) {

            setDisplayAlert( { type: 'danger', msg: validation.validationMsg } );
		    setTimeout(() => { setDisplayAlert( { type: '', msg: '' } ); }, 5000);

            return;

        }

        setSending(true);

        try {

            const response = await fetch(
                `${configVars.apiUrl}sustainchange/v1/handlecontactemail/?first_name=${encodeURIComponent(firstName)}&last_name=${encodeURIComponent(lastName)}&email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}&message=${encodeURIComponent(message)}`,
                {
                  method: "GET",
                  headers: {
                    Authorization: `Basic ${configVars.auth}`,
                  },
                }
            );
    
            const emailResponse = await response.json();
    
            if ( emailResponse ) {
                if ( emailResponse.sent === true ) {
                    setDisplayAlert( { type: 'success', msg: 'Thank you for sending us a message. One of our representatives will get back to you shortly.' } );
		            setTimeout(() => { setDisplayAlert( { type: '', msg: '' } ); }, 5000);
                } else {
                    setDisplayAlert( { type: 'danger', msg: 'Something went wrong. Please try again later.' } );
		            setTimeout(() => { setDisplayAlert( { type: '', msg: '' } ); }, 5000);
                }
            }

            setSending(false);

            setFirstName('');
            setLastName('');
            setEmail('');
            setPhone('');
            setMessage('');

        } catch (error) {
            console.log({ error });
            setSending(false);
		    return { error: error };
        }

        //console.log( validation );
        
    }

    const handleValidation = (firstName, lastName, email, message) => {

        let isValidated = true;
        let validationMsg = '';

        if ( ! firstName.toString().trim().length || ! lastName.toString().trim().length || ! email.toString().trim().length || ! message.toString().trim().length ) {
            isValidated = false;
            validationMsg = translation("fill_required_fields");
        }

        if ( !validator.isEmail(email) ) {
            isValidated = false;
            validationMsg = translation("enter_valid_email");
        }

        return {
            'isValidated' : isValidated,
            'validationMsg': validationMsg
        }

    }

    return (
        <div className="main-wrapper">
			<Helmet>
				<title>Kontakta oss</title>
				<meta name="description" content="" />
			</Helmet>

			<Navigation />

			<div className="page-content-wrap">
				
				<HorizontalNav title="Kontakta oss" />
				
				<div className="pt-5 pt-lg-0 px-3 px-lg-4 page-content-inner" style={{maxWidth: "1440px"}}>

                    <div className="row">
                        <div className="col-12 col-lg-7 mt-4">
                            <h3 className="mb-4">Skicka oss ett meddelande</h3>

                            <div className="contact-form-wrap">
                                { displayAlert.type.length > 0 && 
                                    <div className="row">
                                        <div className="col-12">
                                            <Alert type={displayAlert.type} msg={displayAlert.msg} />
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-3">
                                        <input type="text" className="form-control" placeholder={translation("your_first_name")} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-lg-6 mb-3">
                                        <input type="text" className="form-control" placeholder={translation("your_last_name")} value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-3">
                                        <input type="email" className="form-control" placeholder={translation("your_email")} value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-lg-6 mb-3">
                                        <input type="text" className="form-control" placeholder="Ditt telefon" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <textarea className="form-control" placeholder="Ditt meddelande" rows="5" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-3">
                                        <button type="button" className="btn btn-primary btn-lg rounded-pill text-white" style={{width: "200px"}} onClick={() => handleSend()} >
                                            <span className="pe-2">Skicka</span>
                                            {sending &&
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                            {!sending &&
                                                <i className="fa fa-paper-plane" aria-hidden="true"></i>
                                            }
                                            
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-5 mt-4">
                            <div className="ps-0 ps-lg-4">
                                <h3 className="mb-4">Kontaktinformation</h3>
                                <div className="my-3">
                                    <i className="fa fa-phone" aria-hidden="true"></i>
                                    <span className="ps-2">Ring oss: <a href="tel:+46708697870">+46 70 869 78 70</a></span>
                                </div>
                                <div className="my-3">
                                    <i className="fa fa-envelope" aria-hidden="true"></i>
                                    <span className="ps-2">Email: <a href="mailto:contact@sustainchange.se">contact@sustainchange.se</a></span>
                                </div>

                                <h3 className="mt-5 mb-3">Följ oss</h3>
                                <div className="d-flex mb-5">
                                    <a href="https://www.instagram.com/sustainchange.se/" className="pe-3 text-decoration-none" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-instagram " aria-hidden="true"></i>
                                        <span className="ps-2">Instagram</span>
                                    </a>
                                    <a href="http://www.facebook.com/enhallbarvardag" className="pe-3 text-decoration-none" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-facebook" aria-hidden="true"></i>
                                        <span className="ps-2">Facebook</span>
                                    </a>
                                    <a href="http://www.linkedin.com/company/hallbarvardag" className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                                        <span className="ps-2">Linkedin</span>
                                    </a>
                                </div>
                           </div>
                        </div>
                    </div>
					
				</div>
			</div>
		</div>
    );
}

export default ContactUs;